import type { UserRole } from "../profile";

export const AuditActorType = {
  USER: "USER",
  ADMIN: "ADMIN",
  SUPER: "SUPER",
  SYSTEM: "SYSTEM",
  WORKER: "WORKER",
  API: "API",
  CRON: "CRON",
  BLOCKCHAIN: "BLOCKCHAIN",
} as const;

export type AuditActorType =
  (typeof AuditActorType)[keyof typeof AuditActorType];

export const AuditEntityType = {
  AUTH: "AUTH",
  TRADE: "TRADE",
  SECURITY: "SECURITY",
  WALLET: "WALLET",
  WALLET_ASSET: "WALLET_ASSET",
  USER: "USER",
  SYSTEM: "SYSTEM",
  ADMIN: "ADMIN",
  SETTING: "SETTING",
  TRANSACTION: "TRANSACTION",
  LEDGER_ENTRY: "LEDGER_ENTRY",
  ESCROW: "ESCROW",
  DISPUTE: "DISPUTE",
  PAYMENT_METHOD: "PAYMENT_METHOD",
  SWAP: "SWAP",
  JOB: "JOB",
  ADVERTISEMENT: "ADVERTISEMENT",
  REVIEW: "REVIEW",
} as const;

export type AuditEntityType =
  (typeof AuditEntityType)[keyof typeof AuditEntityType];

export const AuditAction = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  REGISTER: "REGISTER",
  CREATE_TRANSACTION: "CREATE_TRANSACTION",
  COMPLETE_TRANSACTION: "COMPLETE_TRANSACTION",
  FAIL_TRANSACTION: "FAIL_TRANSACTION",
  CREATE_TRADE: "CREATE_TRADE",
  RELEASE_ESCROW: "RELEASE_ESCROW",
  CANCEL_TRADE: "CANCEL_TRADE",
  OPEN_DISPUTE: "OPEN_DISPUTE",
  CREATE_SWAP: "CREATE_SWAP",
  COMPLETE_SWAP: "COMPLETE_SWAP",
  FREEZE_WALLET: "FREEZE_WALLET",
  UNFREEZE_WALLET: "UNFREEZE_WALLET",
  KYC_SUBMITTED: "KYC_SUBMITTED",
  KYC_APPROVED: "KYC_APPROVED",
  KYC_REJECTED: "KYC_REJECTED",
  ADMIN_UPDATE_SETTINGS: "ADMIN_UPDATE_SETTINGS",
  SECURITY: "SECURITY",
} as const;

export type AuditAction = (typeof AuditAction)[keyof typeof AuditAction];

export const AuditLevel = {
  INFO: "INFO",
  SUCCESS: "SUCCESS",
  WARNING: "WARNING",
  ERROR: "ERROR",
} as const;

export type AuditLevel = (typeof AuditLevel)[keyof typeof AuditLevel];

export interface AuditTrace {
  ipAddress?: string;
  userAgent?: string;
  requestId?: string;
  correlationId?: string;
  sessionId?: string;
  deviceId?: string;
}

export interface AuditLog {
  id: string;
  actorId: string | null;
  actor: {
    id: string;
    email: string;
  };
  actorRole: UserRole;
  actorType: AuditActorType;
  action: AuditAction;
  entityType: AuditEntityType;
  entityId: string | null;
  transactionId: string | null;
  tradeId: string | null;
  walletId: string | null;
  title: string | null;
  description: string | null;
  level: AuditLevel;
  trace: AuditTrace | null;
  changes: Record<string, any> | null;
  metadata: Record<string, any> | null;
  success: boolean;
  errorMessage: string | null;
  riskScore: number | null;
  flagged: boolean;
  createdAt: string;
}

export interface ArrayMeta {
  hasNextPage: boolean;
  hasPrevPage: boolean;
  limit: number;
  page: number;
  total: number;
  totalPages: number;
}

export interface AuditLogInterface {
  data: AuditLog[];
  meta: ArrayMeta;
}
